import { Literal, Static, Union } from "runtypes";

import { getNormalEnum } from "../../runtypeEnums";

export const AgentChatThreadTypeLiteral = Union(
  // MagicEvent-based threads
  Literal("LOGIC_VIEW"),
  // AgentChatMessage-based threads
  Literal("LOGIC_VIEW_V2"),
  Literal("ASK"),
  Literal("SEMANTIC_AUTHORING"),
  Literal("CHAT_WITH_APP"),
  // Unused/dormant
  Literal("EXPLORE"),
);
export type AgentChatThreadType = Static<typeof AgentChatThreadTypeLiteral>;
export const AgentChatThreadType = getNormalEnum(AgentChatThreadTypeLiteral);

export type LogicViewChatState = "closed" | "chat" | "history";
export const AgentEntryPointLiteral = Union(
  Literal("FIX_CELL_WITH_AGENT"),
  Literal("SLACK"),
  Literal("MCP"),
);
export type AgentEntryPoint = Static<typeof AgentEntryPointLiteral>;
export const AgentEntryPoint = getNormalEnum(AgentEntryPointLiteral);

export * from "./agentChatMessageTypes";
